let creationFunction; 



function showLoader(content)
{
    content.style.height = '100%'
    content.style.overflow = 'hidden';
    let scrim = document.getElementById("summaryScrim");
    scrim.style.opacity = 1; 
    scrim.style.visibility = "visible";
}

function hideLoader(content)
{
    content.style.height = "auto";
    content.style.overflow = "auto";
    let scrim = document.getElementById("summaryScrim");
    scrim.style.opacity = 0; 
    scrim.style.visibility = "hidden"; 

}

export function showSummaryModal (summary) {
    let summaryTitle = document.getElementById("summaryTitle");
    summaryTitle.innerHTML = `<h1>${summary.title}</h1>`

    let summaryModal = document.getElementById("summaryModal");
    summaryModal.open = true;
    



    

    

   

}

export async function setLoaders (summary) {

    let modal = document.getElementById('summaryModal'); 
    await customElements.whenDefined("calcite-modal");
    await modal.componentOnReady();
    
    for (const [key, value] of Object.entries(summary.summaryDivs)) {
        if (value.innerHTML == "")
        {
            let displayKey = key.replace(/([A-Z])/g, ' $1').toLowerCase();
            value.innerHTML = `<calcite-loader label="loading ${displayKey}..."></calcite-loader><span class="d-block w-100 text-center">Loading ${displayKey}<span>`
        }
    }
      

    let bar = modal.shadowRoot.querySelector("#summaryProgress");
    bar.value = 0;

    let printButton = document.getElementById("printSummary");
    printButton.disabled = true; 


    let finishLoad = (() => {
        printButton.addEventListener("click", () => {
            printSummary(); 
        }); 
        printButton.disabled = false; 
        clearInterval(int);
        let contentDiv = document.getElementById("summaryContainer"); 

        let content = modal.shadowRoot.querySelector(".content"); 
        // hideLoader(content);

    })


    let content = document.getElementById("summaryModalContent"); 
    let divs = content.children; 
    
    let lastTally; 
    let int = setInterval(() => {
        if (bar.value < 1) {
            let tally = 1;     
            for (const [key, value] of Object.entries(divs)) {
                if (value.innerHTML != "")
                {
                    tally += 1; 
                } 
            }
    
            bar.value = (tally / divs.length);
        }
        else {
            finishLoad();
        }

    }, 1000);


    setTimeout(() => {
        clearInterval(int); 
        finishLoad(); 
    }, 10000);



        
} 
    

export async function createSummaryModal (ModalOptions) {
    return new Promise ((resolve, reject) => {
        let modal = document.createElement('calcite-modal'); 
        modal.id = "summaryModal";
        modal.style = "z-index: 10000;";
        modal.beforeClose = () => {
            document.getElementById("summaryImage").remove();
            let content = modal.shadowRoot.querySelector(".content"); 
            // showLoader(content);
            

        }

        (async () => {
            await customElements.whenDefined("calcite-modal");
            await modal.componentOnReady();

            // const updatebutton = document.getElementById("releaseNotesButton");
            // const updatemodal = document.getElementById("ReleaseNotesModal");
            // updatemodal.shadowRoot.querySelector(".modal").style.width = "100%";
            // updatebutton?.addEventListener("click", function () {
            //     modal.open = true;
            // });


            modal.shadowRoot.querySelector(".header").style = "background-color: #274861";
            modal.shadowRoot.querySelector(".modal").style = "width: 95%; border-radius: 0;";
            let progressDiv = document.createElement('calcite-progress');
            progressDiv.id = "summaryProgress"; 
            progressDiv.style.height = '8px';
            progressDiv.style.backgroundColor = "#274861"; 
            progressDiv.value = "0";
            modal.shadowRoot.querySelector(".modal").prepend(progressDiv);



            let content = modal.shadowRoot.querySelector(".content"); 
            // showLoader(content);
      
          })();

        let headerDiv = document.createElement('div');
        headerDiv.slot = "header"; 

        headerDiv.id = "summaryTitle"
        modal.appendChild(headerDiv);
        



        let contentDiv = document.createElement('div'); 
        contentDiv.id = "summaryContent";
        contentDiv.slot = "content"; 
        
        contentDiv.innerHTML = `
        <div id='summaryContainer' class="uniContain p-0 contentContain container-fluid">


  
                <div id='mapCol' class="col-md-5">
                    <!-- <h2>Summary</h2> -->
                    <div id="summaryMap" class="summaryMap" style="width: 100%; aspect-ratio: 1/1;"></div>
                </div>
                <div id="summaryModalContent" class="col-md-7 d-flex  flex-wrap">
  
                            
                </div>


            <!-- <hr class="featurette-divider"> -->
        </div><!-- /.container -->

        `;
        
        
        modal.appendChild(contentDiv);

        let printButton = document.createElement('calcite-button');
        printButton.iconStart = "print";
        printButton.slot = "primary";
        printButton.id = "printSummary";
        printButton.disabled = true;
        printButton.textContent = "Print Summary";
        modal.appendChild(printButton); 
        
        document.body.appendChild(modal);

        let shareButton = document.createElement('calcite-button'); 
        shareButton.iconStart = "link";
        shareButton.slot = "secondary"; 
        shareButton.id = "shareSummary"; 
        shareButton.disabled = false; 
        shareButton.textContent = "Copy Summary Link"; 
        modal.appendChild(shareButton); 



        resolve(); 

    })

}
export function printSummary() {
    // Open a new window with a blank page
    var mywindow = window.open('', 'PRINT');

    // Clear any pre-existing content
    mywindow.document.write('');
    mywindow.document.close();
    
    let title = document.title; 
    title = title.replace("| WinGIS", "");
    title = title.replace("Summary", "");

    let date = new Date; 
    // Write the new HTML content to the new window
    mywindow.document.write(`
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Parcel Summary</title>
            <!-- Fonts-->
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap" rel="stylesheet">
            <link rel="stylesheet" href="https://use.typekit.net/nhs1kgh.css">
            <link rel="stylesheet" href="https://use.typekit.net/qdq8bmq.css">
            <!-- Bootstrap -->
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css">
            <!-- Custom stylesheets -->
                
            <link rel="stylesheet" href="${RootUrl}css/printStyles.css">
        </head>
        <body>
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-3 d-flex align-items-center">
                        <img class="img-fluid" src="/img/wglogobig.png" alt="Logo">
                    </div>
                    <div class="col-9 d-flex align-content-center flex-wrap" style="padding-top: 5px"> 
                        <h1 class="fs-3">| ${title} Summary |</h1>                 
                        <span style="align-self: center;">
                            ${date.toLocaleDateString("en-US")}
                        </span>
                    </div>
                </div>

                ${document.getElementById("summaryContent").innerHTML}
             </div>
        </body>
        </html>
    `);

    mywindow.document.close(); // Ensure all document writes are completed

    let mobileAndTabletCheck = function() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };

     if (!mobileAndTabletCheck())
     {
         setTimeout(function() {
             mywindow.print();
             mywindow.close();
         }, 500);
     }

    return true;
}
